import React, { useState } from 'react'
import Header from '../Header'
import Helmet from 'react-helmet'
import { useParams, useHistory, Link } from 'react-router-dom'
import { getTransaction, refundTransaction } from '../api'
import { useAuth } from '../auth'
//import { isOperator, hasContextContractID } from '../auth-roles'
import { useInterval } from '../timing/use-interval'
import AmountWithCurrency from '../AmountWithCurrency'
import TxnID from './TxnID'
import TxnStatus from './TxnStatus'

const LIVE_UPDATE_INTERVAL = 30000 // ms

/** RefundTxn allows an operator to refund a transaction upstream. */
const RefundTxn = () => {
  const { token } = useAuth()
  const params = useParams()
  const history = useHistory()

  // Form: Change status
  const [refund, setRefund] = useState({
    req: {},
    res: null,
    saving: false,
    failed: null,
  })

  // Transaction data
  const [loading, setLoading] = useState(false)
  const [failed, setFailed] = useState()
  const [txn, setTxn] = useState()
  const fetchTxn = async () => {
    if (!params.id) {
      return
    }
    setLoading(true)
    setFailed(false)
    try {
      const result = await getTransaction(token, params.id)
      setTxn(result)
      setRefund({
        ...refund,
        req: { ...refund.req, amount: result.total_settled, transaction_id: result.transaction_id },
      })
    } catch (failed) {
      setFailed(failed)
    }
    setLoading(false)
  }

  useInterval(fetchTxn, LIVE_UPDATE_INTERVAL, true)

  // Submit button
  const handleSubmit = async () => {
    try {
      setRefund({ ...refund, saving: true, failed: null })
      const res = await refundTransaction(token, refund.req)
      setRefund({ ...refund, saving: false, res })
      // Auto-navigate to transactoin detail view
      history.push(`/transaction/${txn?.transaction_id}`)
    } catch (failed) {
      setRefund({ ...refund, saving: false, failed })
    }
  }

  return (
    <section className='transaction refund'>
      <Header />
      <Helmet>
        <title>Refund Transaction {txn ? txn.transaction_id : ''}</title>
      </Helmet>
      <div className='content'>
        {loading && !txn && <p className='loading'>Loading...</p>}
        {failed && (
          <p className='error'>
            Something went wrong - please try again, or <Link to='/support'>contact support</Link>.
          </p>
        )}
        {!failed && txn && (
          <>
            <div className='txn-refund'>
              <h1>
                <i className='fas fa-undo'></i> Refund transaction
              </h1>

              <div className='txn'>
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td>Transaction</td>
                        <td>
                          <TxnID {...txn} />
                        </td>
                      </tr>
                      <tr>
                        <td>Current status</td>
                        <td>
                          <TxnStatus {...txn} />
                        </td>
                      </tr>
                      <tr>
                        <td>Cardholder</td>
                        <td>{txn.sale_request?.card_holder?.contact?.email || '(unknown)'}</td>
                      </tr>
                      <tr>
                        <td>Amount</td>
                        <td>
                          <AmountWithCurrency {...refund?.req?.amount} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <p className='note'>Note: This will request a refund via the upstream PSP API.</p>

              {refund.failed && (
                <p className='error'>
                  That didn&apos; work - please try again or{' '}
                  <Link to='/support'>contact support</Link>.
                </p>
              )}
            </div>
            <footer className='actions'>
              <Link to={`/transaction/${txn.transaction_id}`}>
                <button className='cancel'>Cancel</button>
              </Link>
              <button onClick={handleSubmit} disabled={refund.saving}>
                {refund.saving ? 'Refunding...' : 'Process refund'}
              </button>
            </footer>
          </>
        )}
      </div>
    </section>
  )
}

export default RefundTxn
